import React from "react";
import { Modal, Text, BlockStack, TextField } from "@shopify/polaris";
import PropTypes from "prop-types";

const DeleteSeller = (props) => {
  const {
    buttonLoading,
    deleteSellerAction,
    handleModalClose,
    handleReasonChange,
    isReasonField,
    openModal,
    reason,
    selectedButton,
    sellerListCMS,
  } = props;
  const { button, label, sectionContent } = sellerListCMS;
  const sellerMessage = <BlockStack gap="2">{`${sectionContent.deleteSellerSelected}`}</BlockStack>;
  return (
    <Modal
      key={label.deleteModal}
      open={openModal}
      onClose={handleModalClose}
      title={label.delete}
      primaryAction={{
        content: button.deleteFromMc,
        onAction: () => deleteSellerAction(false, label.primaryDelete),
        loading: (selectedButton === label.primaryDelete && buttonLoading) || false,
      }}
      secondaryActions={[
        {
          content: button.deleteFromShop,
          onAction: () => deleteSellerAction(true, label.secondaryDelete),
          loading: (selectedButton === label.secondaryDelete && buttonLoading) || false,
        },
      ]}
      sectioned
    >
      <Modal.Section>
        <Text as="span">{sellerMessage}</Text>
        <br />
        {isReasonField && <TextField label={label.reason} value={reason} onChange={handleReasonChange} multiline={4} />}
      </Modal.Section>
    </Modal>
  );
};

DeleteSeller.defaultProps = {
  reason: "",
  selectedButton: "",
  openModal: false,
  isReasonField: false,
  buttonLoading: false,
  handleModalClose: () => {},
  deleteSellerAction: () => {},
  handleReasonChange: () => {},
};

DeleteSeller.propTypes = {
  reason: PropTypes.string,
  selectedButton: PropTypes.string,
  openModal: PropTypes.bool,
  buttonLoading: PropTypes.bool,
  isReasonField: PropTypes.bool,
  handleModalClose: PropTypes.func,
  deleteSellerAction: PropTypes.func,
  handleReasonChange: PropTypes.func,
  sellerListCMS: PropTypes.func.isRequired,
};

export default DeleteSeller;
